import React from 'react';
import ReactDOM from 'react-dom';
import UpcomingEventsContainer from './containers/EventsContainer.jsx';

const date_now_in_seconds = Math.floor(new Date().getTime() / 1000);
const url = `/blogs/events/?view=event-json&upcoming=true&date=${date_now_in_seconds}`;
let upcoming_events = null;

const UpcomingEventsApp = (props) => {
  return <UpcomingEventsContainer events={props.events} />;
};

const getUpcoming = () => {
  return new Promise((resolve, reject) => {
    if (upcoming_events) {
      resolve(upcoming_events);
    }
    fetch(url)
      .then((response) => response.text())
      .then((res) => {
        const _res = res
          .replace(/\\n/g, '\\n')
          .replace(/\\'/g, "\\'")
          .replace(/\\"/g, '\\"')
          .replace(/\\&/g, '\\&')
          .replace(/\\r/g, '\\r')
          .replace(/\\t/g, '\\t')
          .replace(/\\b/g, '\\b')
          .replace(/\\f/g, '\\f')
          // eslint-disable-next-line no-control-regex
          .replace(/[\u0000-\u0019]+/g, '');
        upcoming_events = JSON.parse(_res);
        resolve(upcoming_events);
      })
      .catch((err) => reject(err));
  });
};

export default () => {
  const upcomingEventsElements = document.querySelectorAll('[data-upcoming-events-load]');
  if (upcomingEventsElements.length < 1) {
    return;
  }

  upcomingEventsElements.forEach(async (el) => {
    await getUpcoming();
    const limit = el.getAttribute('data-limit');
    const events = upcoming_events.events.slice(0, limit);
    ReactDOM.render(<UpcomingEventsApp events={events} />, el);
  });
};
